import { APIResponseType } from './types';
import apiService from './index';

// Feedback API response type based on the image provided
export interface FeedbackResponse {
  user_id: string;
  user_email: string;
  user_name: string;
  type: string;
  title: string;
  message: string;
  status: string;
  priority: string;
  _id: string;
  created_at: string;
  updated_at: string;
  __v: number;
}

// Feedback request payload
export interface FeedbackRequest {
  message: string;
  dealer_id?: string;
  time_zone: string;
  images: File[];
}

class FeedbackApiService {
  private static readonly ENDPOINT = 'api/v2/feedback';

  /**
   * Submit feedback
   * @param payload - Feedback payload containing message, dealer_id, time_zone, and images
   * @returns Promise with feedback response
   */
  static async submitFeedback(
    payload: FeedbackRequest
  ): Promise<APIResponseType<FeedbackResponse>> {
    try {
      if (!payload.message || !payload.time_zone) {
        throw new Error('Message and time_zone are required');
      }

      // Create FormData for file uploads
      const formData = new FormData();
      formData.append('message', payload.message);
      if (payload.dealer_id) {
        formData.append('dealer_id', payload.dealer_id);
      }
      formData.append('time_zone', payload.time_zone);

      // Append images if any
      if (payload.images && payload.images.length > 0) {
        payload.images.forEach((file, index) => {
          formData.append('images', file);
        });
      }

      const response = await apiService.post<FeedbackResponse>(
        this.ENDPOINT,
        formData,
        undefined,
        false // Disable caching for POST requests
      );

      return response;
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  }
}

export default FeedbackApiService;

